import React, { useState, useEffect } from 'react'
import { Table, Row, Message } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function UserDataTable({
  schema,
  subName,
  onRemove,
  onReload,
  onEdit,
  pagination,
  lengthMenu,
  loading,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)

  const defaultPage = 1

  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleRemove = (obj) => {
    console.log('obj', obj)
    setDeleteObj(obj)
    setIsShowConfirm(true)
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const TagCell = ({ rowData, dataKey, ...props }) => {
    console.log('row ', rowData[dataKey])
    let _color = ''
    if (rowData.userStatus === 'Active') {
      _color = '#b5ead6'
    } else {
      _color = '#dfb3b3'
    }
    return (
      <Cell {...props} style={{ padding: 13 }}>
        <div
          className="tag"
          style={{
            backgroundColor: _color,
          }}
        >
          <span className="tag__text">{rowData[dataKey]}</span>
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Table
        wordWrap
        height={400}
        loading={loading}
        // autoHeight={schema.values?.length <= 5}
        data={pagination && typeof onReload !== 'function' ? getData() : schema.values || []}
      >
        <Column width={60} align="center">
          <HeaderCell>
            <span>No.</span>
          </HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1 + (page * displayLength - displayLength)
            }}
          </Cell>
        </Column>
        <Column minWidth={250} width={250} flexGrow={1}>
          <HeaderCell align="center">
            <span>{schema.titleUserName}</span>
          </HeaderCell>
          <Cell dataKey="userName" />
        </Column>
        <Column width={250}>
          <HeaderCell align="center">
            <span>{schema.titleFirstName}</span>
          </HeaderCell>
          <Cell dataKey="firstName" />
        </Column>
        <Column width={250}>
          <HeaderCell align="center">
            <span>{schema.titleLastName}</span>
          </HeaderCell>
          <Cell dataKey="lastName" />
        </Column>
        <Column width={150} align="center">
          <HeaderCell>
            <span>{schema.titleUserStatus}</span>
          </HeaderCell>
          {/* <Cell dataKey="userStatus" /> */}
          <TagCell dataKey="userStatus" />
        </Column>
        <Column width={180} align="center">
          <HeaderCell>
            <span>{schema.titleContactInfo}</span>
          </HeaderCell>
          <Cell dataKey="contactNumber" />
        </Column>
        <Column width={120} fixed="right" align="center">
          <HeaderCell>จัดการ</HeaderCell>

          <Cell>
            {(rowData) => {
              return (
                <span>
                  <a
                    onClick={(e) => {
                      onEdit(rowData)
                    }}
                  >
                    {`แก้ไข`}
                  </a>
                  {` | `}
                  <a
                    style={{ color: '#fa8900' }}
                    onClick={(e) => {
                      handleRemove(rowData)
                    }}
                  >
                    {`ลบ`}
                  </a>
                </span>
              )
            }}
          </Cell>
        </Column>
      </Table>

      {pagination && (
        <TablePagination
          lengthMenu={lengthMenu || defaultLengthMenu}
          activePage={page || defaultPage}
          renderLengthMenu={(lengthMenu) => {
            return (
              <>
                {lengthMenu}
                {`รายการ/หน้า`}
              </>
            )
          }}
          renderTotal={(total) => {
            return <>{` ทั้งหมด ${total} รายการ`}</>
          }}
          displayLength={displayLength || 5}
          total={schema.totalSize}
          onChangePage={handleChangePage}
          onChangeLength={handleChangeLength}
        />
      )}

      {schema?.message && (
        <Row>
          <Message showIcon type={schema.message.type} description={schema.message.message} />
        </Row>
      )}

      <ConfirmWidget
        title={`ยืนยันการลบผู้ใช้งาน`}
        show={isShowConfirm}
        detail={`ยืนยันการลบผู้ใช้งาน : ${deleteObj?.userName}`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => {
          setIsShowConfirm(false)
          onRemove(deleteObj)
        }}
      />
    </>
  )
}
